import { InfoCard, CardWrapper } from '../index';
import { useTranslation } from 'react-i18next';
import { CurrencyCode, toCurrencyString } from '@client/toolkit';
import { colors } from '../../../../../styles/color-tokens';
import { MoneyDto, OverdueCustomerDto } from '@client/api';
import { NoDataWidget } from '../../../dashboard-basic-view/components/NoDataWidget/no-data-widget';
import { Link, useLocation } from 'react-router-dom';
import { ReportingPaths } from '../../../../reporting/reporting.router';

interface OutstandingPaymentListCardProps {
  overdueCustomers: OverdueCustomerDto[];
  totalOverdueAmount: MoneyDto;
}

export const OutstandingPaymentListCard = ({
  overdueCustomers,
  totalOverdueAmount,
}: OutstandingPaymentListCardProps) => {
  const { t } = useTranslation('widget');
  const { search } = useLocation();
  if (overdueCustomers.length === 0) {
    return (
      <NoDataWidget title={t('outstandingPayment.listTitle')} noDataText={t('outstandingPayment.noOverdueCustomers')} />
    );
  }

  return (
    <Link to={ReportingPaths.OverdueInvoices + search}>
      <CardWrapper title={t('outstandingPayment.listTitle')}>
        {overdueCustomers.map((customer) => (
          <InfoCard
            key={customer.customerId}
            name={customer.customerName}
            amount={customer.amount.value}
            chipLabel={t('outstandingPayment.chipLabel', { overdueDays: customer.daysLate })}
            chipColor={colors.status.error}
          />
        ))}
        <span className="w-full text-center text-sm text-white p-2">
          {t('outstandingPayment.totalOutstandingAmount', {
            amount: toCurrencyString(totalOverdueAmount.value, undefined, {
              currency: totalOverdueAmount.currency as CurrencyCode,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }),
          })}
        </span>
      </CardWrapper>
    </Link>
  );
};
